// extracted by mini-css-extract-plugin
export default {"root":"Socials_root__XE-g0","link":"Socials_link__WF93z"};